import { AddressInputUniDriver } from '../AddressInput/AddressInput.uni.driver';

export interface AtlasAddressInputUniDriver extends AddressInputUniDriver {}
